/* Oft zusammen bestellt: ein Tipp legt die 2-ml-Probe in den Warenkorb – genau wie der Warenkorb-Knopf von Dawn (product-form.js), also Drawer und Zähler aktualisieren.
   Ein Chip bleibt dunkel mit Haken, solange seine Probe im Warenkorb liegt; nach jeder Warenkorb-Änderung wird das mit /cart.js abgeglichen. */
(function () {
  if (window.ppvOftZusammen) return;
  window.ppvOftZusammen = true;

  var FALLBACK_ERROR = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';

  function showError(block, message) {
    var box = block && block.querySelector('.ppv-oz__error');
    if (!box) return;
    box.textContent = message || FALLBACK_ERROR;
    clearTimeout(box.ppvTimer);
    box.ppvTimer = setTimeout(function () {
      box.textContent = '';
    }, 6000);
  }

  function hideError(block) {
    var box = block && block.querySelector('.ppv-oz__error');
    if (!box) return;
    clearTimeout(box.ppvTimer);
    box.textContent = '';
  }

  function setAdded(chip, added) {
    var name = chip.dataset.name || '';
    if (added) {
      chip.setAttribute('data-added', '');
      chip.setAttribute('aria-disabled', 'true');
      chip.setAttribute('aria-label', name + ', 2 ml liegt im Warenkorb');
    } else {
      chip.removeAttribute('data-added');
      chip.removeAttribute('aria-disabled');
      chip.setAttribute('aria-label', name + ', 2 ml in den Warenkorb legen');
    }
  }

  var syncTimer;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 250);
  }

  function sync() {
    var chips = document.querySelectorAll('.ppv-oz__chip');
    if (!chips.length) return;
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) {
          inCart[String(item.variant_id)] = true;
        });
        chips.forEach(function (chip) {
          if (chip.getAttribute('aria-busy') === 'true') return;
          setAdded(chip, Boolean(inCart[chip.dataset.variantId]));
        });
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleSync();
  });

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.ppv-oz__chip');
    if (!chip || chip.hasAttribute('data-added') || chip.getAttribute('aria-busy') === 'true') return;

    var block = chip.closest('[data-ppv-oz]');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var hasPubSub = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

    var body = new FormData();
    body.append('id', chip.dataset.variantId);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(chip);
    }

    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    hideError(block);
    chip.setAttribute('aria-busy', 'true');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          if (hasPubSub) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'ppv-oft-zusammen',
              productVariantId: chip.dataset.variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          showError(block, response.description || response.message);
          return;
        }

        setAdded(chip, true);

        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (hasPubSub) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ppv-oft-zusammen',
            productVariantId: chip.dataset.variantId,
            cartData: response,
          });
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(function (error) {
        console.error(error);
        showError(block);
      })
      .finally(function () {
        chip.removeAttribute('aria-busy');
      });
  });
})();
